
  import * as userEditorScriptEntry from '/home/builduser/work/352520362e26f24e/packages/universal-editor-app/src/editor.app.ts';
  const editorScriptEntry = userEditorScriptEntry;

  

  import { initI18nWithoutICU as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


  

    var createExperiments = null;
    var createWidgetExperiments = null;
    

  
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    


  import { createOwnerBILogger as biLogger } from '/home/builduser/work/352520362e26f24e/packages/universal-editor-app/target/generated/bi/createBILogger.ts';

  
  import { editorReadyWrapper, onEventWrapper, createFlowAPIFabric, exportsWrapper, getAppManifestWrapper } from '@wix/yoshi-flow-editor/runtime/esm/editorScript.js';

  let editorReady = editorScriptEntry.editorReady;
  const onEvent = onEventWrapper({ onEvent: editorScriptEntry.onEvent });
  const sentryConfig = {
    DSN: 'https://b488c7c3cd8016b92accbf38107927ad@o37417.ingest.us.sentry.io/4509169271701504',
    id: '4509169271701504',
    projectName: 'universal-editor-app',
    teamName: 'wix-blocks',
    errorMonitor: true,
  };
  const experimentsConfig = {"scopes":["universal-editor-app"],"centralized":false};
  const translationsConfig = {"enabled":true,"icuEnabled":false,"defaultTranslationsPath":"/home/builduser/work/352520362e26f24e/packages/universal-editor-app/src/assets/locales/messages_en.json","availableLanguages":["ar","cs","da","de","en","es","fi","fr","hi","hr","id","it","ja","ko","lv","nl","no","pl","pt","ru","sv","th","tr","uk","vi","zh"]};
  const defaultTranslations = {"My_Business_Custom_App_Upgrade_Label_Note":"To get more features,","My_Business_Custom_App_Widgets_CTA":"Discover more widgets","Universal_Design_Presets_Widget_Design_Panel_Header":"Widget Design","Universal_Error_Widget_Panel_Text":"We’re experiencing a technical issue and can’t open this panel. Wait a few minutes and try again.","Universal_Error_Widget_Panel_Header":"Panel Can’t Be Opened Right Now","My_Business_Custom_App_Pages_CTA":"Manage pages","My_Business_Custom_App_Upgrade_CTA":"upgrade now.","My_Business_Custom_App_Upgrade_Label":"To get more features,","Universal_Error_Widget_Panel_Link":"Try Again","Universal_Design_Presets_Widget_Design_Panel_Section_Header":"Discover More Designs","My_Business_Custom_App_Open_Dashboard_CTA":"Go to Dashboard"};
  const createFlowAPI = createFlowAPIFabric({
    sentryConfig,
    experimentsConfig,
    translationsConfig,
    defaultTranslations,
    biLogger,
    shouldUseEssentials: true,
    artifactId: 'universal-editor-app',
    appDefId: 'universal-editor-app',
    optionalDeps: {
      initI18n,
      createHttpClient,
      createExperiments,
    },
    localeDistPath: 'assets/locales',
  });

  const useAPIsFromExports = typeof editorScriptEntry.exports === "function";
  if (editorReady) {
    editorReady = editorReadyWrapper({
      editorReady,
      createFlowAPI,
      shouldSkipAPIOverrides: useAPIsFromExports,
    });
    if (false) {
      const hot = require('@wix/yoshi-flow-editor/build/cjs/wrappers/editorScriptHot.js').hot;
      editorReady = hot(module, editorReady)
    }
  }
  export { editorReady };
  export { onEvent };
  export const exports = useAPIsFromExports ? exportsWrapper(editorScriptEntry.exports) : editorScriptEntry.exports;
  export const getAppManifest = editorScriptEntry.getAppManifest ? getAppManifestWrapper(editorScriptEntry.getAppManifest, createFlowAPI) : undefined;
  export const handleAction = editorScriptEntry.handleAction;
  
